// Spanish
import locale_es from './es/local.json';
import app_es from './es/app.json';
import advance_settings_es from './es/advance_settings.json';
import consumer_stats_es from './es/consumer_stats.json';
import training_settings_es from './es/training_settings.json';
import conversations_es from './es/conversations.json';
import payments_es from './es/payments.json';
import campaigns_es from './es/campaigns.json';
import activity_es from './es/activity.json';
import permissions_settings_es from './es/permissions_settings.json';
import navigation_es from './es/navigation.json';
import profile_page_es from './es/profile_page.json';
import teams_es from './es/teams.json';
import onboarding_es from './es/onboarding.json';
import calendar_es from './es/calendar.json';
import media_library_es from './es/media_library.json';
import media_uploader_es from './es/media_uploader.json';
import faq_editor_es from './es/faq_editor.json';
import dashboard_es from './es/dashboard.json';
import login_es from './es/login.json';
import integration_es from './es/integrations.json';
import store_es from './es/store.json';
import training_documents_es from './es/training_documents.json';
import schedule_es from './es/schedule.json';
import admin_es from './es/admin.json';
import referrals_es from './es/referrals.json';
import customer_es from './es/customer.json';
import forms_es from './es/forms.json';
import collab_es from './es/collab.json';

// English
import locale_en from './en/local.json';
import app_en from './en/app.json';
import advance_settings_en from './en/advance_settings.json';
import consumer_stats_en from './en/consumer_stats.json';
import training_settings_en from './en/training_settings.json';
import conversations_en from './en/conversations.json';
import payments_en from './en/payments.json';
import activity_en from './en/activity.json';
import campaigns_en from './en/campaigns.json';
import permissions_settings_en from './en/permissions_settings.json';
import navigation_en from './en/navigation.json';
import profile_page_en from './en/profile_page.json';
import teams_en from './en/teams.json';
import onboarding_en from './en/onboarding.json';
import calendar_en from './en/calendar.json';
import media_library_en from './en/media_library.json';
import media_uploader_en from './en/media_uploader.json';
import faq_editor_en from './en/faq_editor.json';
import dashboard_en from './en/dashboard.json';
import login_en from './en/login.json';
import integration_en from './en/integrations.json';
import store_en from './en/store.json';
import training_documents_en from './en/training_documents.json';
import schedule_en from './en/schedule.json';
import admin_en from './en/admin.json';
import referrals_en from './en/referrals.json';
import customer_en from './en/customer.json';
import forms_en from './en/forms.json';
import collab_en from './en/collab.json';

export const resources = {
  es: {
    app: app_es,
    locale: locale_es,
    conversations: conversations_es,
    advance_settings: advance_settings_es,
    consumer_stats: consumer_stats_es,
    training_settings: training_settings_es,
    payments: payments_es,
    campaigns: campaigns_es,
    permissions_settings: permissions_settings_es,
    navigation: navigation_es,
    activity: activity_es,
    profile_page: profile_page_es,
    teams: teams_es,
    onboarding: onboarding_es,
    calendar: calendar_es,
    media_library: media_library_es,
    training_documents: training_documents_es,
    media_uploader: media_uploader_es,
    faq_editor: faq_editor_es,
    dashboard: dashboard_es,
    login: login_es,
    integration: integration_es,
    store: store_es,
    schedule: schedule_es,
    admin: admin_es,
    referrals: referrals_es,
    customer: customer_es,
    forms: forms_es,
    collab: collab_es,
  },
  en: {
    app: app_en,
    locale: locale_en,
    advance_settings: advance_settings_en,
    conversations: conversations_en,
    consumer_stats: consumer_stats_en,
    training_settings: training_settings_en,
    training_documents: training_documents_en,
    campaigns: campaigns_en,
    permissions_settings: permissions_settings_en,
    navigation: navigation_en,
    payments: payments_en,
    activity: activity_en,
    profile_page: profile_page_en,
    teams: teams_en,
    onboarding: onboarding_en,
    calendar: calendar_en,
    media_library: media_library_en,
    media_uploader: media_uploader_en,
    faq_editor: faq_editor_en,
    dashboard: dashboard_en,
    login: login_en,
    integration: integration_en,
    store: store_en,
    schedule: schedule_en,
    admin: admin_en,
    referrals: referrals_en,
    customer: customer_en,
    forms: forms_en,
    collab: collab_en,
  },
};
